import { BinderMinimal, BinderSmall } from '@/models/binder.model';
import { Sort } from '@/models/sort.model';
import { HttpClient } from '@angular/common/http';
import { effect, inject, Injectable, signal } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BindersService {
//inject services
  private http: HttpClient = inject(HttpClient);

  selectedBinder = signal<BinderSmall | null>(null);
  binderFormVisible = signal(false);

//signals
  loading = signal(false);
  binders = signal<BinderSmall[]>([]);
  totalRecords = signal(0);

//constants
  private BASE_URL = environment.landmark_API_URL + "/binders";

//constructor
  constructor(
  ) { 

  }

  getItems(params: { page: number, pageSize: number, sortField: string | string[] | null | undefined, sortOrder: number | null | undefined, projectStatus: string[] | null | undefined }): Observable<any> {
    const filteredParams: { [key: string]: string | number | string[] } = {};
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        filteredParams[key] = value;
      }
    });
    return this.http.get<any>(this.BASE_URL, { params: filteredParams });
  }

  getItemsView(params: { page: number, pageSize: number }, viewId: number): Observable<any> {
    const filteredParams: { [key: string]: string | number | string[] } = {};
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        filteredParams[key] = value;
      }
    });
    return this.http.get<any>(this.BASE_URL + '/view/' + viewId, { params: filteredParams });
  }

  getFilteredItems(page: number, pageSize: number, filter: string, sortMeta: Sort[]): Observable<any> {
    const body = {
      page: page,
      pageSize: pageSize,
      filter: filter,
      sortMeta: sortMeta
    }
    return this.http.post<any>(this.BASE_URL + '/filtered', body);
  }

  setSelectedBinder(binder: BinderSmall | null) {
    this.selectedBinder.set(binder);
  }

  loadItemsLazy(event: TableLazyLoadEvent, mode: 'all' | 'draft' | 'pending' | 'staging' | 'complete' = 'all') {
    this.loading.set(true);
  console.log('event', event);
    const page = event.first! / event.rows!;
    const pageSize = event.rows!;
    const sortField = event.sortField;
    const sortOrder = event.sortOrder;
    let projectStatus: string[] | null = null;
    if(mode === 'draft') {
      projectStatus = ['9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20'];
    } else if(mode === 'pending') {
      projectStatus = ['8'];
    } else if(mode === 'staging') {
      projectStatus = ['7'];
    } else if(mode === 'complete') {
      projectStatus = ['21'];
    } else if(mode === 'all') {
        projectStatus = null;
      }
  
    this.getItems({
      page,
      pageSize,
      sortField,
      sortOrder,
      projectStatus
    }).subscribe({
      next: (res) => {
        this.binders.set(res.data);
        this.totalRecords.set(res.total);
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }

  loadViewLazy(page: number, pageSize:number, viewId: number, sortMeta: Sort[], filter: any) {
    this.loading.set(true);
  
    this.getItemsView(
      {
      page,
      pageSize
    },
    viewId
  ).subscribe({
      next: (res) => {
        this.binders.set(res.data);
        this.totalRecords.set(res.total);
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }

  lookupPrelim(binderId: number) {
    return this.http.get<BinderMinimal>(this.BASE_URL + '/minimal/prelim/' + binderId);
  }

  loadFilteredLazy(page: number, pageSize:number, filter: string, sortMeta: Sort[]) {
    this.loading.set(true);
  
    this.getFilteredItems(
      page,
      pageSize,
      filter,
      sortMeta
  ).subscribe({
      next: (res) => {
        this.binders.set(res.data);
        this.totalRecords.set(res.total);
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }

}
